import React from 'react'
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from "prop-types";

const CheckboxWrapper = ({onChange, label,...rest}) => {

    const onCheckboxChange = (e,data) => {
        if(onChange){
            onChange(data.checked)
        }
    }

    return (
        <Form.Field key="Compare" {...rest}>
            <label>{label}</label>
            <Checkbox 
                onChange={onCheckboxChange} 
            />
        </Form.Field>
    ) 
}

CheckboxWrapper.propTypes = {
    onChange: PropTypes.func,
    label: PropTypes.string,
}

export default CheckboxWrapper;